import "./Scoreboard.css";

/* ── School color palette ─────────────────────────────── */
const SCHOOL_COLORS = {
  "CITU":       { bg: "rgba(0,120,215,0.18)",  border: "rgba(0,120,215,0.45)",  color: "#4db8ff" },
  "FEU-TECH":   { bg: "rgba(0,180,80,0.18)",   border: "rgba(0,180,80,0.45)",   color: "#00d458" },
  "DLSU":       { bg: "rgba(0,160,70,0.18)",   border: "rgba(0,160,70,0.45)",   color: "#00c853" },
  "DLSU-D":     { bg: "rgba(0,140,60,0.18)",   border: "rgba(0,140,60,0.45)",   color: "#69f0ae" },
  "CAVSU-MAIN": { bg: "rgba(180,40,40,0.18)",  border: "rgba(180,40,40,0.45)",  color: "#ff6b6b" },
  "MU":         { bg: "rgba(200,80,0,0.18)",   border: "rgba(200,80,0,0.45)",   color: "#ff9a3c" },
  "PLP":        { bg: "rgba(120,0,180,0.18)",  border: "rgba(120,0,180,0.45)",  color: "#ce93d8" },
  "PUP-SR":     { bg: "rgba(180,0,60,0.18)",   border: "rgba(180,0,60,0.45)",   color: "#f48fb1" },
};

const DEFAULT_BADGE = { bg: "rgba(0,212,88,0.08)", border: "rgba(0,212,88,0.25)", color: "rgba(0,212,88,0.7)" };

/* ── School logo lookup by abbreviation ───────────────── */
const SCHOOL_LOGOS = {
  "CITU":       "/pics/LogoSchools/CITU.png",
  "FEU-TECH":   "/pics/LogoSchools/FEU-TECH.png",
  "DLSU":       "/pics/LogoSchools/DLSU.png",
  "DLSU-D":     "/pics/LogoSchools/DLSU-D.png",
  "CAVSU-MAIN": "/pics/LogoSchools/CAVSU-MAIN.png",
  "MU":         "/pics/LogoSchools/MU.png",
  "PLP":        "/pics/LogoSchools/PLP.png",
  "PUP-SR":     "/pics/LogoSchools/PUP-SR.png",
};

/* ── School logo lookup by full name ──────────────────── */
const SCHOOL_LOGOS_BY_FULLNAME = {
  "Cebu Institute of Technology-University":                          "/pics/LogoSchools/CITU.png",
  "University of Batangas":                                           "/pics/LogoSchools/UB.png",
  "Far Eastern University - Institute of Technology":                 "/pics/LogoSchools/FEU-TECH.png",
  "Far Eastern University - Institue of Technology":                  "/pics/LogoSchools/FEU-TECH.png",
  "De La Salle University - Dasmariñas":                              "/pics/LogoSchools/DLSU-D.png",
  "De La Salle University - Manila":                                  "/pics/LogoSchools/DLSU.png",
  "Cavite State University - Main Campus":                            "/pics/LogoSchools/CAVSU-MAIN.png",
  "Mapua University - Manila":                                        "/pics/LogoSchools/MU.png",
  "Pamantasan ng Lungsod ng Pasig":                                   "/pics/LogoSchools/PLP.png",
  "Bulacan State University":                                         "/pics/LogoSchools/BULSU.png",
  "Rizal Technological University":                                   "/pics/LogoSchools/RTU.png",
  "Polytechnic University of the Philippines - Santa Rosa Campus":    "/pics/LogoSchools/PUP-SR.png",
  "Polytechnic University of the Philippines - Maragondon Campus":    "/pics/LogoSchools/PUP-C.png",
  "University of Santo Tomas - Manila":                               "/pics/LogoSchools/UST.png",
  "Technological Institute of the Philippines - QC":                  "/pics/LogoSchools/TIP.png",
  "Technological Institute of the Philippines - Manila":              "/pics/LogoSchools/TIP.png",
  "Colegio De San Gabriel Arcangel":                                  "/pics/LogoSchools/CDGSA.png",
  "Lyceum of the Philippines University - Cavite":                    "/pics/LogoSchools/LPU.png",
  "National University - Manila":                                     "/pics/LogoSchools/NU-M.png",
  "Colegio de Muntinlupa":                                            "/pics/LogoSchools/CDM.png",
  "Far Eastern University - Alabang":                                 "/pics/LogoSchools/FEU-A.png",
  "Polytechnic University of the Philippines - Manila":               "/pics/LogoSchools/PUP.png",
};

/* ── Data ─────────────────────────────────────────────── */
const RP_FINALS = [
  {
    match: 1,
    p1: { name: "Ardiente, Rohan",        school: "CITU",     score: 9, winner: true  },
    p2: { name: "Almero, Fhaez Michael C.", school: "FEU-TECH", score: 3, winner: false },
  },
];

const RP_SEMIS = [
  {
    match: 1,
    p1: { name: "Ardiente, Rohan",             school: "CITU",     score: 16, winner: true  },
    p2: { name: "Crisaldo, Nathaniel Dale S.", school: "DLSU",     score: 12, winner: false },
  },
  {
    match: 2,
    p1: { name: "Almero, Fhaez Michael C.",    school: "FEU-TECH", score: 8,  winner: true  },
    p2: { name: "San Diego, Earl Clarence S.", school: "CAVSU-MAIN", score: 4, winner: false },
  },
];

const RP_QUARTERS = [
  {
    match: 1,
    p1: { name: "Crisaldo, Nathaniel Dale S.", school: "DLSU",       score: 15, winner: true  },
    p2: { name: "Cruz, Marc Andrei L.",         school: "MU",          score: 11, winner: false },
  },
  {
    match: 2,
    p1: { name: "San Diego, Earl Clarence S.", school: "CAVSU-MAIN",  score: 15, winner: true  },
    p2: { name: "Taon, Antonio M.",             school: "PLP",          score: 0,  winner: false },
  },
  {
    match: 3,
    p1: { name: "Almero, Fhaez Michael C.",    school: "FEU-TECH",    score: 19, winner: true  },
    p2: { name: "Capate, Allen Cris R.",        school: "PUP-SR",       score: 0,  winner: false },
  },
  {
    match: 4,
    p1: { name: "Ardiente, Rohan",             school: "CITU",         score: 18, winner: true  },
    p2: { name: "Gatbunton, Jethroe L.",        school: "DLSU-D",       score: 5,  winner: false },
  },
];

const RP_WRITTEN = [
  { rank:1,  name:"Ardiente, Rohan",                        school:"Cebu Institute of Technology-University",                              score:72 },
  { rank:2,  name:"Plata, Eric Andrei T.",                   school:"University of Batangas",                                               score:68 },
  { rank:3,  name:"Almero, Fhaez Michael C.",                school:"Far Eastern University - Institute of Technology",                     score:60 },
  { rank:4,  name:"Gatbunton, Jethroe L.",                   school:"De La Salle University - Dasmariñas",                                  score:58 },
  { rank:5,  name:"Crisaldo, Nathaniel Dale S.",             school:"De La Salle University - Manila",                                      score:56 },
  { rank:6,  name:"San Diego, Earl Clarence S.",             school:"Cavite State University - Main Campus",                                score:53 },
  { rank:7,  name:"Cruz, Marc Andrei L.",                    school:"Mapua University - Manila",                                            score:50 },
  { rank:8,  name:"Taon, Antonio M.",                        school:"Pamantasan ng Lungsod ng Pasig",                                       score:46 },
  { rank:9,  name:"Macatangay, Juanico Daren C.",            school:"University of Batangas",                                               score:45 },
  { rank:10, name:"Bernardo, Aldwyn James N.",               school:"Bulacan State University",                                             score:43 },
  { rank:11, name:"Aguilar, Katherine F.",                   school:"Pamantasan ng Lungsod ng Pasig",                                       score:43 },
  { rank:12, name:"Cabilatazan, Lian Bray R.",               school:"Rizal Technological University",                         score:37 },
  { rank:13, name:"Enriquez, Johnrel S.",                    school:"Far Eastern University - Institute of Technology",                     score:37 },
  { rank:14, name:"Capate, Allen Cris R.",                   school:"Polytechnic University of the Philippines - Santa Rosa Campus",        score:36 },
  { rank:15, name:"De Mesa, Jonvictor L.",                   school:"Polytechnic University of the Philippines - Maragondon Campus",        score:35 },
  { rank:16, name:"Elgarico, Kyle Christian Joshua M.",      school:"University of Santo Tomas - Manila",                                   score:35 },
  { rank:17, name:"Jaictin, Ken Joshua B.",                  school:"Far Eastern University - Institute of Technology",                     score:34 },
  { rank:18, name:"Castillo, Gian carlo",                    school:"Technological Institute of the Philippines - QC",                     score:34 },
  { rank:19, name:"Pada, Dexter Andrei M.",                  school:"Rizal Technological University",                         score:33 },
  { rank:20, name:"Montemayor, Robert Joshua",               school:"Colegio De San Gabriel Arcangel",                                      score:32 },
  { rank:21, name:"Santos, Lancelot Mil Q.",                 school:"Lyceum of the Philippines University - Cavite",                        score:32 },
  { rank:22, name:"Cruz, Cris Jericho A.",                   school:"Rizal Technological University",                         score:32 },
  { rank:23, name:"Lativo, Mark Jerome F.",                  school:"National University - Manila",                                         score:29 },
  { rank:24, name:"Gabuco, James Francis N.",                school:"Technological Institute of the Philippines - Manila",                  score:29 },
  { rank:25, name:"Desquitado, Jexter",                      school:"Rizal Technological University",                              score:28 },
  { rank:26, name:"Yambot, Epsilon Omni C.",                 school:"Rizal Technological University",                              score:28 },
  { rank:27, name:"Bernaldez, Kim O.",                       school:"Lyceum of the Philippines University - Cavite",                        score:27 },
  { rank:28, name:"Mazon, Princess Allia D.",                school:"University of Santo Tomas - Manila",                                   score:27 },
  { rank:29, name:"Tan, Angelo V.",                          school:"Pamantasan ng Lungsod ng Pasig",                                       score:26 },
  { rank:30, name:"Bartolome, Ken Brian B.",                 school:"Technological Institute of the Philippines - QC",                     score:26 },
  { rank:31, name:"La Guardia, Josiah David L.",             school:"University of Santo Tomas - Manila",                                   score:25 },
  { rank:32, name:"Costanilla, Alyssa Jane S.",              school:"Colegio de Muntinlupa",                                                score:24 },
  { rank:33, name:"Correa, Charls Gerald D.",                school:"Mapua University - Manila",                                            score:24 },
  { rank:34, name:"Kagaoan, Altair G.",                      school:"Mapua University - Manila",                                            score:24 },
  { rank:35, name:"Villapando, Jed Nathan L.",               school:"Mapua University - Manila",                                            score:24 },
  { rank:36, name:"Suson, Gilbert M.",                       school:"Pamantasan ng Lungsod ng Pasig",                                       score:24 },
  { rank:37, name:"Bartonico, Janlem Angelo DC.",            school:"Far Eastern University - Institute of Technology",                     score:23 },
  { rank:38, name:"Ulep, Cheena Marie N.",                   school:"Pamantasan ng Lungsod ng Pasig",                                       score:23 },
  { rank:39, name:"Geroleo, Jefrey",                         school:"University of Batangas",                                               score:23 },
  { rank:40, name:"Hernandez, Rudolph Dave Nestor D.",       school:"Colegio de Muntinlupa",                                                score:22 },
  { rank:41, name:"Dela Cruz, Peter John G.",                school:"Far Eastern University - Institute of Technology",                     score:21 },
  { rank:42, name:"Fusin, Benedict R.",                      school:"Polytechnic University of the Philippines - Manila",                   score:21 },
  { rank:43, name:"Zarco, Ma. Alexis Inrah G.",              school:"Far Eastern University - Institue of Technology",                      score:19 },
  { rank:44, name:"Encenzo, Pamela Isabelle April L.",       school:"Rizal Technological University",                         score:19 },
  { rank:45, name:"Josef, Jayzie Dre G.",                    school:"Technological Institute of the Philippines - QC",                     score:19 },
  { rank:46, name:"Ricohermoso, John Lloyd L.",              school:"Technological Institute of the Philippines - Manila",                  score:19 },
  { rank:47, name:"Barrion, John Earl Stephen P.",           school:"Far Eastern University - Alabang",                                     score:18 },
  { rank:48, name:"Aguinaldo, Paul Clarence G.",             school:"Far Eastern University - Alabang",                                     score:18 },
  { rank:49, name:"Fronda, Johann Michael T.",               school:"National University - Manila",                                         score:18 },
  { rank:50, name:"Utanes, Jhulianne Clark F.",              school:"Technological Institute of the Philippines - QC",                      score:18 },
  { rank:51, name:"Manzano, Eljon Grei M.",                  school:"Far Eastern University - Institue of Technology",                      score:16 },
  { rank:52, name:"Raagas, Bryan Roy G.",                    school:"Rizal Technological University",                              score:16 },
  { rank:53, name:"Vela Cruz, Alyssa A.",                    school:"Rizal Technological University",                              score:16 },
  { rank:54, name:"Lacanaria, Celina Jane P.",               school:"Rizal Technological University",                         score:16 },
  { rank:55, name:"Malayas, Tyrone Jay",                     school:"Rizal Technological University",                         score:16 },
  { rank:56, name:"Noma, Bea Marie G.",                      school:"University of Santo Tomas - Manila",                                   score:16 },
  { rank:57, name:"Merluza, Jan Nester E.",                  school:"Rizal Technological University",                         score:16 },
  { rank:58, name:"Paz, Gavin Rossdale A.",                  school:"University of Batangas",                                               score:16 },
  { rank:59, name:"Mendoza, Alliah Zaki B.",                 school:"Polytechnic University of the Philippines - Manila",                   score:15 },
  { rank:60, name:"Leynes, Cedric James F.",                 school:"Bulacan State University",                                             score:14 },
  { rank:61, name:"Castillo, Kathleen",                      school:"Colegio De San Gabriel Arcangel",                                      score:14 },
  { rank:62, name:"Nuestro, Sophia Alyssandra M.",           school:"Far Eastern University - Alabang",                                     score:13 },
  { rank:63, name:"Reyes, Rae Andre M.",                     school:"National University - Manila",                                         score:13 },
  { rank:64, name:"Sagun, Justine Andrei",                   school:"National University - Manila",                                         score:13 },
  { rank:65, name:"De Rivera, Joshua Miguel C.",             school:"Colegio de Muntinlupa",                                                score:12 },
  { rank:66, name:"Calamlam, Khalila N.",                    school:"Far Eastern University - Institute of Technology",                     score:11 },
  { rank:67, name:"Nolasco, Adam Kalel A.",                  school:"Far Eastern University - Alabang",                                     score:11 },
  { rank:68, name:"Pua, Alyzandra D.",                       school:"Far Eastern University - Institue of Technology",                      score:11 },
  { rank:69, name:"Marcaida, Cedrick C.",                    school:"Rizal Technological University",                         score:11 },
  { rank:70, name:"Gonzales, Daniel Elijah C.",              school:"Technological Institute of the Philippines - QC",                     score:11 },
  { rank:71, name:"Fetalvero, Khim M.",                      school:"Colegio de Muntinlupa",                                                score:10 },
  { rank:72, name:"Sy, Alessandra Marini D.",                school:"Colegio de Muntinlupa",                                                score:10 },
  { rank:73, name:"Gantan, Ma. Elisha L.",                   school:"Far Eastern University - Institue of Technology",                      score:10 },
  { rank:74, name:"Del Rosario, Mark Christian H.",          school:"Rizal Technological University",                         score:10 },
  { rank:75, name:"Alvior, Kirby Dengel D.",                 school:"Rizal Technological University",                         score:9  },
  { rank:76, name:"Barlaan, Marc Joseph R.",                 school:"University of Batangas",                                               score:9  },
  { rank:77, name:"Rivera, Neil Janzent D.",                 school:"Far Eastern University - Institute of Technology",                     score:9  },
  { rank:78, name:"Reyes, Rafael Emnuel M.",                 school:"Lyceum of the Philippines University - Cavite",                        score:8  },
  { rank:79, name:"Padernal, Eleazar S.",                    school:"Rizal Technological University",                              score:8  },
  { rank:80, name:"Punzalan, Giem",                          school:"Lyceum of the Philippines University - Cavite",                        score:6  },
  { rank:81, name:"Manantan, Joie Nicole D.",                school:"Far Eastern University - Institue of Technology",                      score:5  },
  { rank:82, name:"Repalda, Danah Mae T.",                   school:"Colegio de Muntinlupa",                                                score:3  },
  { rank:83, name:"Galzote, Johanna Pearl",                  school:"Colegio De San Gabriel Arcangel",                                      score:3  },
  { rank:84, name:"Santos, Dayle David T.",                  school:"Far Eastern University - Alabang",                                     score:3  },
  { rank:85, name:"De Leon, Johen Ryugakusei D.",            school:"Polytechnic University of the Philippines - Manila",                   score:3  },
  { rank:86, name:"Quillopas, Rafael G.",                    school:"Polytechnic University of the Philippines - Santa Rosa Campus",        score:3  },
  { rank:87, name:"Capul, Julius R.",                        school:"Polytechnic University of the Philippines - Santa Rosa Campus",        score:3  },
  { rank:88, name:"Torio, Peterson B.",                      school:"Bulacan State University",                                             score:0  },
  { rank:89, name:"Gaddi, Russel Jhay",                      school:"Colegio De San Gabriel Arcangel",                                      score:0  },
  { rank:90, name:"Punzalan, Keith Eisen M.",                school:"Far Eastern University - Alabang",                                     score:0  },
  { rank:91, name:"Villegas, Anthony P.",                    school:"Lyceum of the Philippines University - Cavite",                        score:0  },
  { rank:92, name:"Agliam, Michael Ian V.",                  school:"Far Eastern University - Alabang",                                     score:0  },
  { rank:93, name:"Ceralde, Jerome Ricardo M.",              school:"Mapua University - Manila",                                            score:0  },
  { rank:94, name:"Mendoza, Alliah Zaki B.",                 school:"Polytechnic University of the Philippines - Manila",                   score:0  },
];

/* ── Components ───────────────────────────────────────── */
function RpLogoBadge({ abbr }) {
  const c = SCHOOL_COLORS[abbr] || DEFAULT_BADGE;
  const logo = SCHOOL_LOGOS[abbr];
  return (
    <div
      className="rp-logo-badge"
      style={{ background: c.bg, borderColor: c.border, color: c.color }}
    >
      {logo
        ? <img src={logo} alt={abbr} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
        : abbr
      }
    </div>
  );
}

function RpMatchCard({ stageLabel, match }) {
  const { p1, p2, match: matchNum } = match;
  return (
    <div className="rp-match-card">
      <div className="rp-match-label">{stageLabel} · Match {matchNum}</div>
      <div className="rp-match-body">
        <div className={`rp-match-side rp-match-side--left${p1.winner ? " rp-winner" : " rp-loser"}`}>
          <RpLogoBadge abbr={p1.school} />
          <div className="rp-match-info">
            <span className="rp-match-name">{p1.name}</span>
            <span className="rp-match-school">{p1.school}</span>
          </div>
          {p1.winner && <span className="rp-win-badge">WIN</span>}
        </div>

        <div className="rp-score-block">
          <span className={p1.winner ? "rp-score-win" : "rp-score-lose"}>{p1.score}</span>
          <span className="rp-score-sep">:</span>
          <span className={p2.winner ? "rp-score-win" : "rp-score-lose"}>{p2.score}</span>
        </div>

        <div className={`rp-match-side rp-match-side--right${p2.winner ? " rp-winner" : " rp-loser"}`}>
          {p2.winner && <span className="rp-win-badge">WIN</span>}
          <div className="rp-match-info rp-match-info--right">
            <span className="rp-match-name">{p2.name}</span>
            <span className="rp-match-school">{p2.school}</span>
          </div>
          <RpLogoBadge abbr={p2.school} />
        </div>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════
   MAIN EXPORT — Static Results Page
   ════════════════════════════════════════════════════════ */
export default function Scoreboard() {
  return (
    <div className="scoreboard-page">
      <div className="rp-page">

        {/* ── SECTION 1: CHAMPION ── */}
        <section className="rp-section rp-section--champion">
          <div className="rp-champion-glow" />
          <div className="rp-trophy">🏆</div>
          <div className="rp-champion-label">BNT 2026 CHAMPION</div>
          <div className="rp-champion-card">
            <RpLogoBadge abbr="CITU" />
            <div className="rp-champion-info">
              <div className="rp-champion-name">Ardiente, Rohan</div>
              <div className="rp-champion-school">Cebu Institute of Technology-University</div>
            </div>
          </div>
        </section>

        {/* ── SECTION 2: FINALS ── */}
        <section className="rp-section">
          <div className="rp-section-header">
            <span className="rp-section-title">Finals</span>
            <span className="rp-section-sub">GRAND FINAL ROUND</span>
          </div>
          {RP_FINALS.map((m) => <RpMatchCard key={m.match} stageLabel="Finals" match={m} />)}
        </section>

        {/* ── SECTION 3: SEMI-FINALS ── */}
        <section className="rp-section">
          <div className="rp-section-header">
            <span className="rp-section-title">Semi-Finals</span>
            <span className="rp-section-sub">SEMI-FINAL ROUND</span>
          </div>
          {RP_SEMIS.map((m) => <RpMatchCard key={m.match} stageLabel="Semi-Finals" match={m} />)}
        </section>

        {/* ── SECTION 4: QUARTER-FINALS ── */}
        <section className="rp-section">
          <div className="rp-section-header">
            <span className="rp-section-title">Quarter-Finals</span>
            <span className="rp-section-sub">QUARTER-FINAL ROUND</span>
          </div>
          {RP_QUARTERS.map((m) => <RpMatchCard key={m.match} stageLabel="Quarter-Finals" match={m} />)}
        </section>

        {/* ── SECTION 5: WRITTEN PHASE ── */}
        <section className="rp-section">
          <div className="rp-section-header">
            <span className="rp-section-title">Written Phase Rankings</span>
            <span className="rp-section-sub">ALL {RP_WRITTEN.length} PARTICIPANTS</span>
          </div>
          <div className="rp-table-wrap">
            <table className="rp-table">
              <thead>
                <tr>
                  <th className="rp-th rp-th--rank">Rank</th>
                  <th className="rp-th rp-th--name">Name</th>
                  <th className="rp-th rp-th--school">School</th>
                  <th className="rp-th rp-th--score">Score</th>
                </tr>
              </thead>
              <tbody>
                {RP_WRITTEN.map((r) => {
                  const isTop1 = r.rank === 1;
                  const isQF   = r.rank <= 8 && r.rank > 1;
                  let trClass = "rp-tr";
                  if (isTop1) trClass += " rp-tr--top1";
                  const schoolLogo = SCHOOL_LOGOS_BY_FULLNAME[r.school];
                  return (
                    <tr key={r.rank} className={trClass} style={isQF ? { borderLeft: "3px solid rgba(0,212,88,0.5)" } : {}}>
                      <td className="rp-td rp-td--rank">{r.rank}</td>
                      <td className="rp-td rp-td--name">{r.name}</td>
                      <td className="rp-td rp-td--school">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {schoolLogo && (
                            <img
                              src={schoolLogo}
                              alt={r.school}
                              style={{ 
                                width: "24px", 
                                height: "24px", 
                                objectFit: "contain", 
                                marginRight: "8px", 
                                flexShrink: 0 /* Prevents the logo from squishing */
                              }}
                            />
                          )}
                          <span>{r.school}</span>
                        </div>
                      </td>
                      <td className="rp-td rp-td--score">{r.score}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </section>

      </div>
    </div>
  );
}
